











import PatientExerciseHistory from '@/components/exercises/components/PatientExerciseHistory.vue'
import { getPatientName } from '@/utils/patients'
import { convertToExercisesByUserAndDate, sortExercisesByDate } from '@/store/modules/exercise/converters'
import SearchForm from '@/components/sub-components/SearchForm.vue'

export default {
  components: {
    PatientExerciseHistory,
    SearchForm,
  },
  props: {
    currentPatientId: {
      type: String,
      default: '',
    },
    exercises: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchText: '',
    }
  },
  computed: {
    filteredPatients() {
      return this.exercises.filter(exercise => {
        return getPatientName({
          id: exercise.patientId,
          lastName: exercise.patientLastName,
          firstName: exercise.patientFirstName,
        })
          .toLowerCase()
          .includes(this.searchText.toLowerCase())
      })
    },
    filteredExercisesByUserAndDate() {
      return convertToExercisesByUserAndDate(sortExercisesByDate(this.filteredPatients))
    },
  },
  watch: {
    '$route.params.exercise_id'() {
      this.searchText = ''
    },
  },
}
